// extracted by mini-css-extract-plugin
export default {"customerUtils":"FaqCounselGroup_customerUtils__pzsNN","utilButtons":"FaqCounselGroup_utilButtons__I1hIc"};